import { api } from "./api";

declare global {
  interface Window { gtag?: (...args: unknown[]) => void }
}

type Params = Record<string, unknown>;

export function track(event: string, params?: Params) {
  if (typeof window === "undefined") return;
  window.gtag?.("event", event, params);
}

export function trackPageView(pathWithSearch: string) {
  track("page_view", {
    page_path: pathWithSearch,
    page_location: window.location.href,
    page_title: document.title,
  });
}

interface CheckoutMeta {
  transaction_id: string;
  value: number;
  currency: string;
  plan: "starter" | "pro";
  cycle: "monthly" | "annual";
}

/**
 * Fire the GA4 `purchase` event. If sessionId is provided, fetch revenue
 * params from /api/billing/checkout-session and include them so GA4 can
 * compute revenue per source. On any failure (404, 502, network error),
 * fall back to a bare `purchase` so the conversion still counts.
 */
export async function trackPurchase(sessionId: string | null) {
  if (!sessionId) {
    track("purchase");
    return;
  }
  try {
    const meta = await api<CheckoutMeta>(`/api/billing/checkout-session?id=${encodeURIComponent(sessionId)}`);
    const planName = meta.plan.charAt(0).toUpperCase() + meta.plan.slice(1);
    track("purchase", {
      transaction_id: meta.transaction_id,
      value: meta.value,
      currency: meta.currency,
      items: [{
        item_id: `${meta.plan}-${meta.cycle}`,
        item_name: planName,
        item_category: meta.cycle,
        price: meta.value,
        quantity: 1,
      }],
    });
  } catch {
    track("purchase");
  }
}
